module.exports = __webpack_public_path__ + "img/alcohol.06e3bb47.svg";